import { render, staticRenderFns } from "./AwsuiTabs.vue?vue&type=template&id=3ddf47a2&"
import script from "./AwsuiTabs.vue?vue&type=script&lang=js&"
export * from "./AwsuiTabs.vue?vue&type=script&lang=js&"
import style0 from "./AwsuiTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports